import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { retrieveThumbnailPath } from './StructureThumbnailService';
import StructureThumbnail from './StructureThumbnail';

function StructureThumbnailContainer(props) {
  const { structure, thumbnailType, enableThumbnail } = props;
  const [thumbnailPath, setThumbnailPath] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchThumbnail = async () => {
      // eslint-disable-next-line no-shadow
      const { thumbnailPath } = await retrieveThumbnailPath(structure, thumbnailType);
      if (isMounted) {
        setThumbnailPath(thumbnailPath);
      }
    };

    if (enableThumbnail) {
      fetchThumbnail();
    }

    return () => {
      isMounted = false;
    };
  }, [structure, thumbnailType, enableThumbnail]);

  return <StructureThumbnail {...props} thumbnailPath={thumbnailPath} />;
}
StructureThumbnailContainer.propTypes = {
  structure: PropTypes.string,
  thumbnailType: PropTypes.string,
  enableThumbnail: PropTypes.bool,
};

export default StructureThumbnailContainer;
